// extracted by mini-css-extract-plugin
export default {"button":"ToolbarButton_button__Tt6II","disabled":"ToolbarButton_disabled__pBFov","active":"ToolbarButton_active__p6iD3"};